import { render, staticRenderFns } from "./ErrorMailModal.vue?vue&type=template&id=8aaf3adc&"
import script from "./ErrorMailModal.vue?vue&type=script&lang=js&"
export * from "./ErrorMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports